import type { IReviewCycleType } from "@performyard/models";

export type CycleType = IReviewCycleType;

export const CYCLE_TYPE_ICON_COLORS: Record<CycleType, string> = {
	manual: "bg-primary-5",
	automated: "bg-green-5",
	group: "bg-orange-5",
};

export type CycleTypeOption = {
	type: CycleType;
	title: string;
	description: string;
	features: string[];
};

export const CYCLE_TYPE_OPTIONS: CycleTypeOption[] = [
	{
		type: "manual",
		title: "Manual Review Cycle",
		description: "Assign reviews to selected employees and/or groups of employees.",
		features: [
			"Add forms ad hoc or from a template",
			"Assign calendar-based due dates",
			"Select specific employees and groups",
			"Reviews generated at cycle creation",
		],
	},
	{
		type: "automated",
		title: "Automated Review Cycle",
		description: "Use configurable rules to automatically assign reviews as employees qualify for assignment.",
		features: [
			"Set as recurring or one-time automated tasks",
			"Assigned with relative due dates",
			"Add forms via template",
			"Defined assignment rules",
		],
	},
	{
		type: "group",
		title: "Group Review Cycle",
		description:
			"Limit reviews to a specific group of employees while allowing a group administrator to assist in managing the cycle.",
		features: [
			"Subjects restricted to the chosen group",
			"Access granted to Group Administrators",
			"Add forms via template and/or ad hoc",
			"Assign and customize due dates",
		],
	},
];
